import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { FC } from 'react';
import { staticFileLocation } from '@server/constants';
import { useNavigate } from 'react-router-dom';
import EastIcon from '@mui/icons-material/East';
import { track } from '@amplitude/analytics-browser';
import { amplitudeEventsName } from '@utils/amplitudeEvents';
type CompanyExpiryModalProps = {
  isExpiryModalOpen: boolean;
  handleClose: () => void;
};

const CompanyExpiryModal: FC<CompanyExpiryModalProps> = ({
  isExpiryModalOpen,
  handleClose,
}) => {
  const navigate = useNavigate();

  const handleAccountNavigation = () => {
    track(amplitudeEventsName.EXPIRED_CLICK_UPGRADE_BUTTON);
    navigate('/employer/account#Manage-Billing');
    handleClose();
  };
  return (
    <Dialog
      open={isExpiryModalOpen}
      maxWidth="xs"
      fullWidth
      disableEnforceFocus
      sx={{ background: 'transparent' }}
    >
      <DialogTitle>
        <Box
          sx={{
            pt: 4,
            textAlign: 'center',
          }}
        >
          <img
            src={`${staticFileLocation}img/logos/LogoStampShadow.png`}
            alt="Logo"
            style={{ width: 60, height: 80, margin: '0 auto', objectFit: 'contain' }}
          />
          <Typography
            variant="body1"
            fontWeight={600}
            color="error.main"
            mt={2}
            mb={1}
          >
            Account Expired
          </Typography>
          <Typography variant="h3" fontWeight={900} color="primary.main" mt={2}>
            Ready to start hiring again?
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Stack
          sx={{ justifyContent: 'center', alignItems: 'center' }}
          spacing={3}
          mb={2}
        >
          <Typography
            variant="subtitle1"
            color="gray"
            sx={{ fontWeight: 500, textAlign: 'center', lineHeight: 1.5 }}
          >
            Choose the right plan for your needs <br /> and find the right hires -{' '}
            <b>fast!</b>
          </Typography>
          <Button
            sx={{ width: 'fit-content' }}
            endIcon={<EastIcon sx={{ fontWeight: 'bold' }} />}
            onClick={handleAccountNavigation}
            variant="contained"
            color="primary"
          >
            Start Hiring Now
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default CompanyExpiryModal;
